import * as z from "zod";

/** No credentials: Uptick's place ids are Redo-global, so connecting is consent. */
export const connectUptickOfferNetwork = {
  name: "connectUptickOfferNetwork" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
